
function Window(data, window) {
  var windowArray = generateWindow(
    window,
    data.length
  );
  var correctionCoefficient = getCorrectionCoefficient(
    window,
    "amplitude"
  );
  for(var i = 0; i < data.length; i++) {
    data[i] = data[i] * windowArray[i] * correctionCoefficient;
  }
  return data
}

function getCorrectionCoefficient(windowType, correctionType) {
  let correctionCoefficient = 1
  switch (windowType) {
    case 'hanning': // Hanning window
      correctionCoefficient = correctionType === 'amplitude' ? 2.0 : 1.63
      break
    case 'hamming': // Hamming window
      correctionCoefficient = correctionType === 'amplitude' ? 1.85 : 1.59
      break
    case 'blackman': // Blackman window
      correctionCoefficient = correctionType === 'amplitude' ? 2.80 : 1.97
      break
    case 'flattop':
      correctionCoefficient = correctionType === 'amplitude' ? 4.18 : 2.26
      break
    default: // Rectangular window function
      correctionCoefficient = 1
  }
  return correctionCoefficient
}
function generateWindow(windowType, nSamples) {
  // generate nSamples window function values
  // for index values 0 .. nSamples - 1
  let m = nSamples / 2
  let r
  let pi = Math.PI
  let w = new Array(nSamples)
  switch (windowType) {
    case 'bartlett': // Bartlett (triangular) window
      for (let n = 0; n < nSamples; n++) {
        w[n] = 1.0 - Math.abs(n - m) / m
      }
      break
    case 'hanning': // Hanning window
      r = pi / (m + 1)
      for (let n = -m; n < m; n++) {
        w[m + n] = 0.5 + 0.5 * Math.cos(n * r)
      }
      break
    case 'hamming': // Hamming window
      r = pi / m
      for (let n = -m; n < m; n++) {
        w[m + n] = 0.54 + 0.46 * Math.cos(n * r)
      }
      break
    case 'blackman': // Blackman window
      r = pi / m
      for (let n = -m; n < m; n++) {
        w[m + n] = 0.42 + 0.5 * Math.cos(n * r) + 0.08 * Math.cos(2 * n * r)
      }
      break
    case 'flattop':
      for (let n = 0; n < nSamples; n++) {
        w[n] = 0.21557895 - 0.41663158 * Math.cos((2 * Math.PI * n) / nSamples) + 0.277263158 * Math.cos((4 * Math.PI * n) / nSamples) - 0.083578947 * Math.cos((6 * Math.PI * n) / nSamples)
      }
      break
    default: // Rectangular window function
      for (let n = 0; n < nSamples; n++) {
        w[n] = 1.0
      }
  }
  return w
}
export {
  Window,
  getCorrectionCoefficient,
  generateWindow,
}
